import menu_dashboard from './menu-dashboard.png';
import menu_exchange_orders from './menu-exchange-orders.png';
import menu_disposals from './menu-disposals.png';
import menu_transfers from './menu-transfers.png';
import menu_messages from './menu-messages.png';
import menu_profile from './menu-profile.png';
import menu_dashboard_active from './menu-dashboard-active.png';
import menu_exchange_orders_active from './menu-exchange-orders-active.png';
import menu_disposals_active from './menu-disposals-active.png';
import menu_transfers_active from './menu-transfers-active.png';
import menu_messages_active from './menu-messages-active.png';
import menu_profile_active from './menu-profile-active.png';
import triangle from './triangle.png';
import help from './help.png';
import checkbox_icon from './checkbox-icon.png';
import back_arrow from './back-arrow.png';
import personal_data from './personal-data.svg';
import personal_data_billing from './personal-data-billing.svg';
import personal_data_cards from './personal-data-cards.svg';
import personal_data_accounts from './personal-data-accounts.svg';
import personal_data_company from './personal-data-company.svg';
import fa_solid_id_card from './icon-park-solid_bank-card.svg';
import icon_park_solid_id_card from './icon-park-solid_id-card.svg';
import forward_menu from './forward-menu.png';
import clock from './clock.png';
import error_icon from './error-icon.png';
import notification_sell from './notification-sell.png';
import notification_buy from './notification-buy.png';
import notification from './notification.png';
import attachment from './attachment.png';
import pdf_icon from './pdf-icon.png';
import important_message from './important-message.png';
import modal_close from './modal-close.png';
import info_svg from './info_svg.svg';
import status_active from './status-active.svg';
import status_canceled from './status-canceled.svg';
import status_completed from './status-completed.svg';
import status_expired from './status-expired.svg';
import status_partial from './status-partial.svg';
import status_pending from './status-pending.svg';
import status_rejected from './status-rejected.svg';
import security_icon from './security-icon.svg';
import filter_icon from './filter-icon.svg';
import konstruktor from './konstruktor.svg';

import tradebull_logo_large from './tradebull-logo-large.png';
import tradebull_logo from './tradebull-logo.png';

import positive from './positive_arrow.png';
import negative from './negative_arrow.png';

export const icons = {
  // menu icons
  menu_dashboard,
  menu_exchange_orders,
  menu_disposals,
  menu_transfers,
  menu_messages,
  menu_profile,
  menu_dashboard_active,
  menu_exchange_orders_active,
  menu_disposals_active,
  menu_transfers_active,
  menu_messages_active,
  menu_profile_active,

  // default screen
  back_arrow,

  // card menus
  forward_menu,

  // login
  tradebull_logo_large,
  konstruktor,

  // personal data
  personal_data,
  personal_data_billing,
  personal_data_cards,
  personal_data_accounts,
  personal_data_company,
  fa_solid_id_card,
  icon_park_solid_id_card,

  // messages/notifications
  clock,
  notification_sell,
  notification_buy,
  notification,
  attachment,
  pdf_icon,
  important_message,

  // statuses
  status_active,
  status_canceled,
  status_completed,
  status_expired,
  status_partial,
  status_pending,
  status_rejected,

  // components
  error_icon,
  triangle,
  tradebull_logo,
  help,
  checkbox_icon,
  modal_close,
  info_svg,
  security_icon,
  filter_icon,

  positive,
  negative,
};
